// The colors of a text block, apart from its component: the editor reads them without loading the widget.

// Variables
// The colors a block had by default, saved in its design: the theme ones (an empty value) now.
const FORMER_DEFAULT_COLORS: Record<string, string> = { backgroundColor: '#FFFFFF', textColor: '#222222', altBackgroundColor: '#FFFFFF' };

// Classes
// A block saved before the theme colors and the accent bar (in place): its former default colors become the theme
// ones, and it gets no accent bar (a new block gets one from the editor).
export function migrateBlockColors(design: any): void {
  if (!design) return;

  const colors = design.colors ??= {};
  colors.accent ??= false;

  Object.entries(FORMER_DEFAULT_COLORS)
    .filter(([name, color]) => `${colors[name] ?? ''}`.toUpperCase() === color)
    .forEach(([name]) => colors[name] = '');
}
